import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import DeleteIcon from '@material-ui/icons/Delete'
import { Dialog } from '@material-ui/core'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import DialogoTareasDelete from '../components/DialogoTareasDelete'
import { FORM_TAREA_MOVIMIENTO } from '../../../../../config/forms'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'

function DeleteTareaMovimiento (props) {
  const { fechaRegistroTarea } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = () => {
    handleClose()
    props.deleteTarea(fechaRegistroTarea)
    props.actualizarDatosMovimientoMercaderiaPendiente(props.destroy)
  }

  function onClick () {
    handleOpen()
  }

  return (
    <div>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xs'>
          <DialogoTareasDelete handleClose={handleClose} handleSubmit={handleSubmit} />
        </Dialog>
        <div>
          <Tooltip title={'Eliminar'}>
            <IconButton onClick={onClick}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {

  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DeleteTareaMovimiento))
